import confirm from "./confirm.js";
import moneyInput from "./money-input.js";

Alpine.directive('confirm', confirm);
Alpine.directive('money-input', moneyInput);
